import percentage from "@/mixins/percentage.js";
import { sumBy } from "lodash";

export default {

  mixins: [percentage],

  methods: {
    // returns stats data for closure-questions-stars
    metaStats(apMeta) {

      apMeta || [];

      // const apMeta = this.ap.meta || {};
      const stats = apMeta.reduce((accumulator, m) => {
        // sum how menu stars the questions got
        const sum = m.result ? sumBy(m.result, function (r) {
          return r.pivot.value;
        }) : 0;

        // total nummber of starts that is possible to get
        const noOfStars = m.result ? m.result.length * 5 : 0;

        // how menu percent it makes
        const percentage = this.percentage(sum, noOfStars).toFixed(1);

        // pack here and return it
        const obj = {
          noOfQuestions: noOfStars,
          summedValues: sum,
          starsAverage: (percentage / 20).toFixed(1),
          percentage: percentage,
          color:
            percentage > 80
              ? "success"
              : percentage > 60
                ? "primary"
                : percentage > 40
                  ? "info"
                  : percentage > 20
                    ? "warning"
                    : "danger"
        };

        accumulator.push(obj);
        return accumulator;
      }, []);


      // {noOfQuestions: 10, summedValues: 9, starsAverage: "4.5", percentage: "90.0", color: "success"}
      return stats;
    }
  }
}